import { render, staticRenderFns } from "./EditCargoCompanyDialog.vue?vue&type=template&id=3297eabb"
import script from "./EditCargoCompanyDialog.vue?vue&type=script&lang=js"
export * from "./EditCargoCompanyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports